import { ListItem, ListItemText } from "common/components";
import { formatDataCy } from "common/utils";
import { FlowData, FlowStep } from "core/api";
import { Fragment } from "react";

export interface CardsConfirmationProps {
  step: FlowStep;
  flowData: FlowData;
  title?: string;
}

/**
 * Sub component to confirmation. The purpose of this component is
 * to make the main Confirmation component more readable,
 * abstracting some of the logic into smaller sub components.
 *
 * CardsConfirmation is specific to confirmation steps where
 * the flow contains a step with the uiComponent: "Cards".
 *
 * @param flowData data property from the flow object, this is fetched through
 * const flowData = flow.data[step.id]; in the parent component.
 *
 * @returns A JSX element with item(s) selected in the Cards component.
 */
export function CardsConfirmation({
  step,
  flowData,
  title,
}: CardsConfirmationProps): JSX.Element {
  const fieldFlowData = flowData.uiComponent === "Cards" ? flowData : undefined;

  return (
    <Fragment key={step.id}>
      <ListItem>
        <ListItemText
          data-cy={title ? formatDataCy(title) : formatDataCy(step.name)}
          primary={title ? title : step.name}
          secondary={fieldFlowData?.selectedNames?.join(", ") || ""}
        />
      </ListItem>
    </Fragment>
  );
}
